import { render, staticRenderFns } from "./OriginatorTab.vue?vue&type=template&id=21aaa02d"
import script from "./OriginatorTab.vue?vue&type=script&lang=js"
export * from "./OriginatorTab.vue?vue&type=script&lang=js"
import style0 from "./OriginatorTab.vue?vue&type=style&index=0&id=21aaa02d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports